import React from 'react';
import { motion } from 'framer-motion';
const chapters = [{
  num: 'Cap. 1',
  title: '¿Relación con futuro o estancada?',
  desc: 'Checklist de señales verdes y rojas + Test de compromiso real con puntaje.'
}, {
  num: 'Cap. 2',
  title: 'La verdad incómoda',
  desc: 'Por qué algunas relaciones no avanzan y las 3 razones reales del estancamiento.'
}, {
  num: 'Cap. 3',
  title: 'Transformación interna',
  desc: 'De novia que espera a mujer de alto valor. Rutina, estándares y reprogramación.'
}, {
  num: 'Cap. 4',
  title: 'La conversación de claridad',
  desc: '12 scripts exactos para distintos escenarios. Sin rogar, sin pelear, con poder.'
}, {
  num: 'Cap. 5',
  title: 'Retirada estratégica',
  desc: 'El plan de 14 días para recuperar tu energía y observar su reacción real.'
}, {
  num: 'Cap. 6',
  title: 'Plan 30 días',
  desc: 'De la claridad a la decisión final. Semáforo de la relación incluido.'
}, {
  num: 'Cap. 7',
  title: 'Cuándo saber que te vas',
  desc: 'Señales claras y cómo cerrar el ciclo con dignidad, elegancia y paz.'
}, {
  num: 'BONUS',
  title: 'El Método Lucía',
  desc: 'Cuaderno de calificación: calculadora de compromiso, plantillas de pros/contras y diario de estándares.',
  isBonus: true
}];
export function ChaptersSection() {
  return <section className="py-10 md:py-14 px-6 bg-white relative" data-id="element-35">
      <div className="max-w-6xl mx-auto" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-37">
          <p className="text-burgundy font-bold uppercase tracking-widest text-sm mb-3" data-id="element-38">
            Lo que encontrarás dentro
          </p>
          <h2 className="text-2xl md:text-4xl font-bold mb-4 text-burgundy" data-id="element-39">
            7 Capítulos + Bonus Exclusivos
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-40">
          {chapters.map((chapter, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`p-4 md:p-6 shadow-md border-t-4 flex flex-col items-start ${chapter.isBonus ? 'bg-burgundy border-gold text-cream md:col-span-2' : 'bg-cream border-burgundy text-gray-900'}`} data-id="element-41">
              <span className={`inline-block px-3 py-1 text-xs font-bold uppercase tracking-widest mb-3 ${chapter.isBonus ? 'bg-gold text-burgundy' : 'bg-burgundy/10 text-burgundy'}`} data-id="element-42">
                {chapter.num}
              </span>
              <h3 className={`text-lg font-bold mb-2 font-serif ${chapter.isBonus ? 'text-gold' : 'text-burgundy'}`} data-id="element-43">
                {chapter.title}
              </h3>
              <p className={`text-sm md:text-base leading-relaxed ${chapter.isBonus ? 'text-cream/90' : 'text-gray-700'}`} data-id="element-44">
                {chapter.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}